import * as React from 'react';

import Tooltip from 'components/Tooltip';
import ActionButton from 'components/buttons/action-button/ActionButton';

import { __t, applyTranslations } from 'utils/language';

import './proposal-autofill-button.scss';

applyTranslations(require('./proposal-autofill-button.i18n.json'));

type Props = {
  onAutofill: () => void,
  loadAllContent?: boolean
};

const AutofillButton = (
  {
    onAutofill,
    loadAllContent
  }: Props
): JSX.Element => (
  <div className="proposal-autofill-button">
    <Tooltip
      message={__t(`proposal_autofill_button_v2.button_tooltip${loadAllContent ? '_all_content' : ''}`)}
      width="long"
    >
      <ActionButton onClick={onAutofill}>
        {__t(`proposal_autofill_button_v2.button_label${loadAllContent ? '_all_content' : ''}`)}
      </ActionButton>
    </Tooltip>
  </div>
);

export default AutofillButton;
